import React from "react";

import { Goals, useGoals } from "../../features/goals";

interface PageStructureProps {
  title: string;
  filter?: string;
}

// page structure component for the goals page
const PageStructure: React.FC<PageStructureProps> = ({ title, filter }) => {
  const goals = useGoals(filter);

  return (
    <section className="page-container primary-py">
      <div className="flex items-end gap-2">
        <h1 className="capitalize text-4xl font-semibold">{title}</h1>
        <small className="sub-text">({goals!.length})</small>
      </div>
      {/* goals */}
      <Goals goals={goals!} />
    </section>
  );
};

export default PageStructure;
